/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Social Media API Documentation
 * <p>Welcome to the API documentation for integrating with Metapic's Social Media Platform.</p>
            <h2>Authentication</h2>
            <p>This API uses <strong>Bearer Token</strong> authentication. You must include a valid token in the <strong>Authorization</strong> header with every request to access protected endpoints.</p>
            <h4>Example:</h4>
            <pre>Authorization: Bearer <i>your_token_here</i></pre>
            <p>*Replace <i>your_token_here</i> with your actual Bearer token. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  ChartParams,
  ChartResponse,
  MetricsParams,
  MetricsResponse,
  SummaryParams,
} from '../metapicSocialMediaAPIDocumentation.schemas'

export const getPerformance = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * @summary Get chart data for an advertiser
   */
  const chart = (
    params: ChartParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ChartResponse>> => {
    return axiosInstance.get(`/v1/performance/chart`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @deprecated
   * @summary Get metrics data for an advertiser (legacy alias of /summary)
   */
  const metrics = (
    params: MetricsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MetricsResponse>> => {
    return axiosInstance.get(`/v1/performance/metrics`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Get performance summary data for an advertiser
   */
  const summary = (
    params: SummaryParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MetricsResponse>> => {
    return axiosInstance.get(`/v1/performance/summary`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return { chart, metrics, summary }
}
export type ChartResult = AxiosResponse<ChartResponse>
export type MetricsResult = AxiosResponse<MetricsResponse>
export type SummaryResult = AxiosResponse<MetricsResponse>
